import { Button } from "primereact/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import useApi from "../../hooks/ApiHook";
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import If from "../../components/If";
import Loading from "../../components/Loading";
import { useEffect, useState } from "react";
import usePaginator from "../../hooks/PaginatorHook";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import FilterPanel, { extractParams } from "../../components/FilterPanel";
import { Dropdown } from "primereact/dropdown";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ products, setProducts ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ stocks, setStocks ] = useState();
    const [ selectedStock, setSelectedStock ] = useState();
    const [ filterModel, setFilterModel ] = useState(JSON.parse(searchParams.get('filters')) || {});
    const [ filterQuery, setFilterQuery ] = useState(extractParams(filterModel));
    const [ expandedRows, setExpandedRows ] = useState(null);

    useEffect(() => {
        api.get(`suppliers?limit=100`).then(({ data }) => {
            setStocks(data.data);
        });
    }, []);

    useEffect(() => {
        if (loading) {
            return;
        }
        setLoading(true);
        const params = {
            page,
            limit,
            "supplier.id": selectedStock?.id,
            ...filterQuery
        }
        api.get(`products`, { params }).then(({ data }) => {
            setProducts(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit, filters: JSON.stringify(filterModel) });
        }).finally(() => setLoading(false));
    }, [page, limit, filterQuery, selectedStock]);

    const actions = product => (
        <>
            <Button icon="pi pi-pencil" title="Editar" onClick={() => navigate('./' + product.id)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    const expansionTemplate = sp => (
        <div className="surface-100 p-1">
            <DataTable value={sp.divisions} rowClassName="surface-100">
                <Column field="supplier.commercialName" header="Distribuidor"></Column>
                <Column body={sp => sp.quantity + sp.unit} header="Quantidade"></Column>
            </DataTable>
        </div>
    );

    return (
        <div>
            <PageTitle title="Produtos" subtitle="Cadastre os produtos da sua empresa" end={titleButtons}/>
            <PageContent>
                <div className="mb-2 flex">
                    <Dropdown
                        className="mr-2"
                        options={stocks}
                        value={selectedStock}
                        optionLabel="commercialName"
                        onChange={e => setSelectedStock(e.value)}
                        placeholder="Distribuidora"
                        showClear={true}
                        disabled={!stocks}/>
                    <Filters model={filterModel} onChange={setFilterModel} onFilter={setFilterQuery}/>
                </div>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable 
                        value={products} 
                        selectionMode="single" 
                        emptyMessage="Nada encontrado"
                        expandedRows={expandedRows}
                        rowExpansionTemplate={expansionTemplate}
                        onRowToggle={e => setExpandedRows(e.data)}>
                        <Column expander={!selectedStock} style={{ width: '5rem' }} />
                        <Column field="code" header="Código" style={{width:'20%'}}></Column>
                        <Column field="description" header="Descrição"></Column>
                        <Column field="eanCode" header="Cód. de barras"></Column>
                        <Column body={p => p.quantity + '' + p.unit} header="Quantidade"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}

const Filters = ({ model, onChange, onFilter }) => {

    const setFilter = (id, name, query, value) => {
        onChange({ ...model, [id]: { name, query, value } })
    }

    const filter = value => {
        onFilter(value.params);
        onChange(value.model);
    }

    return (
        <FilterPanel model={model} onFilter={filter}>
            <div className="formgrid grid">
                <div className="field">
                    <label>Descrição</label>
                    <InputText
                        className="w-full"
                        value={model.description?.value || ''}
                        onChange={e => setFilter('description', 'Descrição', 'description[includes]', e.target.value)}/>
                </div>
                <div className="field">
                    <label>Cód. de barras</label>
                    <InputText
                        className="w-full"
                        value={model.ean?.value || ''}
                        onChange={e => setFilter('ean', 'EAN', 'eanCode', e.target.value)}/>
                </div>
            </div>
        </FilterPanel>
    );
}